import React, { useState } from 'react';

import ConfirmationModal from '../ConfirmationModal'
 
import AdminListActionsDropdown from './AdminListActionsDropdown';
import { useMediaQuery } from 'react-responsive';

const AdminTableRow = ({ admin, handleChangeStatus, handleDeleteUser, }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);


  const handleShowDeactivateModal = () => setShowDeactivateModal(true);
  const handleCloseDeactivateModal = () => setShowDeactivateModal(false);



  const confirmDeactiavateUser = () => {
    handleChangeStatus(admin, admin.active)
    handleCloseDeactivateModal();
  };

  const confirmDeleteUser = () => {
    handleDeleteUser(admin.id);
    handleCloseDeleteModal();
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <>
    {isMobile ? (
           <div className="admin-card-list">
          
             <div className="admin-card el-bg-table mb-2" >

               <div className="card-header">

               <div className="card-actions" style={{height:'10px'}}>
                <div style={{float:'right'}}>
                <AdminListActionsDropdown admin={admin}  handleShowDeactivateModal={handleShowDeactivateModal} handleShowDeleteModal={handleShowDeleteModal}/>
                </div>
                 {/* <button className="btn btn-primary">View Details</button>
                 <button className="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal">
                   Deactivate
                 </button>
                 <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteuser">
                   Delete
                 </button> */}
               </div>


                 <h5>{admin.first_name} {admin.middle_name} {admin.last_name}</h5>
                 <p>{admin.is_superadmin ? "super-admin" : "admin"}</p>
               </div>
                
               <div className=  {"card-body "} >
                 
                 <p><strong>Email:</strong> {admin.email}</p>
                 <p><strong>Phone:</strong> {admin.phone_number}</p>
                 <p>
                   <strong>Status:</strong>{" "}
                   <span className={admin.active ? "badge bg-success" : "badge bg-danger"}>
                     {admin.active ? "Active" : "Inactive"}
                   </span>
                 </p>
               </div>
          
             </div>
           
         </div>
         ):(<>

      <tr>
        <td>{admin.first_name} {admin.middle_name} {admin.last_name}</td>
        <td>{admin.is_superadmin ? "super-admin" : "admin"}</td>
        {/* <td>{admin.id}</td> */}
        <td>{admin.email}</td>
        <td>{admin.phone_number}</td>
        <td>
          <div className={admin.active ? "el-active" : "el-inactive"}>
            <div className={admin.active ? "el-activebtn" : "el-inactive"}></div>
            {admin.active ? "Active" : "Inactive"}
          </div>
        </td>
        <td>
         <AdminListActionsDropdown admin={admin}  handleShowDeactivateModal={handleShowDeactivateModal} handleShowDeleteModal={handleShowDeleteModal}/> 
        </td>
      </tr>
</>
         )}
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={confirmDeleteUser}
        title="Confirm Delete"
        body="Are you sure you want to delete this user?"
      />

      {/* Deactiavate Confirmation Modal */}
      < ConfirmationModal
        show={showDeactivateModal}
        onHide={handleCloseDeactivateModal}
        onConfirm={confirmDeactiavateUser}
        title=""
        body={`Are you sure you want to ${admin.active ? 'deactivate' : 'activate'} user?`}
        type='deactivateactivate'
      />

      {/* <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this user?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDeleteUser}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default AdminTableRow;
